package fr.manyverse.app.presentation.components

import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import fr.manyverse.app.presentation.error.UserErrorNotifier
import fr.manyverse.app.presentation.error.toUserMessage
import kotlinx.coroutines.flow.collectLatest
import org.koin.compose.koinInject

/**
 * Affiche en snackbar les échecs signalés au [UserErrorNotifier].
 *
 * Posé à la racine de l'app, et dans chaque `Dialog` ou bottom sheet plein écran où le MJ agit
 * (fiche d'un joueur) : c'est une fenêtre à part, qui masquerait le snackbar de la racine.
 * Les overlays rendus dans l'arbre de l'écran (tableau blanc, combat…) n'en ont pas besoin.
 */
@Composable
fun UserErrorSnackbarHost(
    modifier: Modifier = Modifier,
    notifier: UserErrorNotifier = koinInject()
) {
    val hostState = remember { SnackbarHostState() }
    LaunchedEffect(notifier) {
        // Le dernier échec remplace le précédent : hors ligne, une série d'actions ratées
        // n'empile pas une file de snackbars identiques
        notifier.errors.collectLatest { error -> hostState.showSnackbar(error.toUserMessage()) }
    }
    SnackbarHost(hostState = hostState, modifier = modifier)
}
